import React from "react";
import { MDBContainer } from "mdbreact";
import { Helmet } from "react-helmet";
import ReactMarkdown from "react-markdown";
import "../styles/background.css";

import HoverImage from "../components/HoverImage";
import CarouselPage from "../components/CarouselPage";

import text from "../text/text.json";

import artist from "../images/headers/ArtistHeader.jpg";
import musician from "../images/headers/MusicHeader.jpg";
import signwriter from "../images/headers/SWHeader.jpg";
import songwriter from "../images/headers/SongHeader.jpg";

import Layout from "../components/Layout";

function Home() {
    return (
        <>
            <Helmet>
                <title>Artistic Wizard | Home</title>
            </Helmet>
            <Layout>
                <CarouselPage />
                <MDBContainer style={{ padding: "20px" }}>
                    <ReactMarkdown>{text.home.body1}</ReactMarkdown>
                    <ReactMarkdown>{text.home.body2}</ReactMarkdown>
                    <ReactMarkdown>{text.home.body3}</ReactMarkdown>
                    <ReactMarkdown>{text.home.body4}</ReactMarkdown>
                    <br />
                    {/*<Typography variant="h3" align="center">Signwriter</Typography>*/}
                    <HoverImage text="" overlay="red-strong" image={signwriter} page="/signwriter" />
                    <br />
                    {/*<Typography variant="h3" align="center">Artist</Typography>*/}
                    <HoverImage text="" overlay="blue-strong" image={artist} page="/artist" />
                    <br />
                    {/*<Typography variant="h3" align="center">Songwriter</Typography>*/}
                    <HoverImage text="" overlay="green-strong" image={songwriter} page="/songwriter" />
                    <br />
                    {/*<Typography variant="h3" align="center">Musician</Typography>*/}
                    <HoverImage text="" overlay="purple-strong" image={musician} page="musician" />
                </MDBContainer>
            </Layout>
        </>
    )
}

export default Home;